export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public
  console.group(`%cBranch: ${config.GIT_BRANCH}`, 'color: #7344c0; font-weight: bold;')
  console.log(`%c🚀 Deployed AM3 Commit: ${config.GIT_HASH}`, 'color: #7344c0; font-weight: bold;')
  console.log(`%c${config.GIT_COMMIT_MESSAGE} - ${config.GIT_COMMIT_TIMESTAMP}`, 'color: #7344c0; font-weight: bold;')
  console.groupEnd()
})
